module.exports = __webpack_public_path__ + "img/appAsset--suppliers-ax.88e47ea7.svg";